import { baserUrl } from '../../../services/ApiService';

export const CENTER = {
	lat: 9.356359,
	lng: -79.897623,
};

export const ZOOM = 16;

// CHANGE GOOGLE MAP API KEY
export const GOOGLE_MAPS_OPTIONS = {
	id: 'google-map-script',
	googleMapsApiKey: 'AIzaSyAsoBCxuKnb5PYX1-j-Z1FY9359a6lrByA',
	libraries: ['places', 'drawing'],
};

export const GOOGLE_MAP_CONTAINER_STYLE = {
	width: '100%',
	height: '100%',
};

export const GOOGLE_MAP_POLYGON_OPTIONS = {
	fillOpacity: 0.3,
	fillColor: '#ff0000',
	strokeColor: '#ff0000',
	strokeWeight: 2,
};

export const getDefaultPath = () => {
	return [
		{ lat: 9.357296, lng: -79.899373 },
		{ lat: 9.357666, lng: -79.89423 },
		{ lat: 9.353093, lng: -79.896829 },
		{ lat: 9.357296, lng: -79.899373 },
	];
};


export const getRemotePlots = () => {
	const URL = `${baserUrl}/plots`;
	return new Promise((resolve, reject) => {
		fetch(URL)
			.then((response) => response.json())
			.then(({ plots }) => {
				resolve(plots);
			})
			.catch(reject);
	});
};

export function saveRemotePlot({ id, path }) {
	const URL = `${baserUrl}/plots/${id}`;
	const options = {
		method: 'PUT',
		headers: {
			'Content-type': 'application/json; charset=UTF-8',
			'Authorization': localStorage.getItem('token')
		},
		body: JSON.stringify({ path })
	}
	console.log(`Update path for plot: ${id}`);
	return new Promise((resolve, reject) => {
		fetch(URL, options)
			.then((response) => response.json())
			.then(({ path }) => {
				console.log(`Success updating path for plot: ${id}`);
				resolve(path);
			})
			.catch(reject);

	});
}

export function mapPlotProperties(row) {
	const {
		plano,
		manzana,
		calle,
		avenida,
		finca,
		inmueble,
		lote,
		tipo,
		propietario,
		condicion,
		categoria,
		area,
		rango,
		certificacion,
		codigo_de_area,
		corregimientos,
		paths,
	} = row;

	return clone({
		plan: plano,
		block: manzana,
		street: calle,
		avenue: avenida,
		estate: finca,
		property: inmueble,
		lot: lote,
		type: tipo,
		owner: propietario,
		condition: condicion,
		category: categoria,
		area,
		range: rango,
		certification: certificacion,
		areaCode: codigo_de_area,
		corrections: corregimientos,
		paths,
	});
}

export const clone = (obj) => {
	return obj ? JSON.parse(JSON.stringify(obj)) : obj;
};
